export default __webpack_public_path__ + "static/media/GreenEllipse.1ab4315f.svg";